export default __webpack_public_path__ + "static/media/photo--lg--109.c0b3ae30.jpg";